// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__VkIvQ","text":"SelectPayment_text__1wArJ","title":"SelectPayment_title__3QM-y","btn":"SelectPayment_btn__3N9Ws"};